import type { FundBasicDetailsDtoIn } from '@/models/in/FundBasicDetailsDtoIn';
import { FundStatus } from '@/models/common/FundStatus';

export type FundsSearchRow = Omit<FundBasicDetailsDtoIn, 'balance' | 'balanceForWithdrawal'> & {
  status: FundStatus;
  balance?: number;
  balanceForWithdrawal?: number;
};

export function matchesFundsSearch(item: FundsSearchRow, value: string): boolean {
  if (!value) return true;
  const searchValue = value.toLowerCase();
  return [item.id?.toString(), item.name].some((field) => field?.toLowerCase().includes(searchValue));
}
